<div class="strategy-preferred-vendors d-flex flex-column" *ngIf="strategyVendors && strategyVendors.length > 0">
  <div class="d-flex align-items-center justify-content-start gap-3 flex-wrap padding-10 vendor-list-box">
    <div class="pointer vendor-list-item" [ngClass]="(currentSelectedVendor && (currentSelectedVendor.name === vendor.name)) ? 'selected-vendor' : ''" (click)="selectVendor(vendor)" *ngFor="let vendor of strategyVendors">
      {{vendor.name || ''}}
    </div>
  </div>

  <div class="d-flex flex-column padding-10 background-color">
    <div class="d-flex flex-column vendor-strategy-box mt-2 mb-2">
      <div class="d-flex">
        <div class="d-flex flex-column">
          <div class="d-flex gap-4">
            <div *ngIf="currentSelectedVendor && currentSelectedVendor.logo" class="vendor-image" [ngStyle]="currentSelectedVendor.logoBg"></div>
            <div class="strategy-name bold" style="padding: 10px 0;">
              {{strategy.name}} by {{currentSelectedVendor.name}}
            </div>
          </div>
          <div class="d-flex flex-column mt-3">
            <div class="offer-title bold">Description</div>
            <div class="offer-description" *ngIf="currentSelectedVendor.description">
              <app-tpiq-froala-view [data]="currentSelectedVendor.description"></app-tpiq-froala-view>
            </div>
            <div class="strategy-view-content"*ngIf="!currentSelectedVendor.description">
              No description available.
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column vendor-contact-box">
        <div class="contact-name bold">{{currentSelectedVendor.contactFirstName}} {{currentSelectedVendor.contactLastName}}</div>
        <div class="contact-divider mt-2"></div>
        <ng-template [ngIf]="currentSelectedVendor.contactEmail">
          <div class="mt-2 contact-label">Contact Email:</div>
          <div class="text">{{currentSelectedVendor.contactEmail}}</div>
        </ng-template>
        <ng-template [ngIf]="currentSelectedVendor.contactPhoneNumber">
          <div class="mt-2 contact-label">Contact Phone:</div>
          <div class="text">{{currentSelectedVendor.contactPhoneNumber}}</div>
        </ng-template>
        <ng-template [ngIf]="currentSelectedVendor.website">
          <div class="mt-2 contact-label">Website:</div>
          <div class="text"><a href="{{currentSelectedVendor.website}}" target="_blank">{{currentSelectedVendor.website}}</a></div>
        </ng-template>
      </div>
    </div>
    <div class="d-flex flex-column padding-10 background-color vendor-strategy-box mt-2 mb-2">
     <div class="d-flex">
        <div class="d-flex flex-column"  style="width: 80%">
          <div class="d-flex flex-column">
            <div class="offer-title bold">Offer Description</div>
            <div class="offer-description" *ngIf="currentSelectedVendor.strategyInfo.description">
              <app-tpiq-froala-view [data]="currentSelectedVendor.strategyInfo.description"></app-tpiq-froala-view>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center" style="width: 20%">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <ng-template [ngIf]="currentSelectedVendor.strategyInfo.offer.offerValue">
              <div class="bold offer-price">{{(currentSelectedVendor.strategyInfo.offer.offerType === 'price' && currentSelectedVendor.strategyInfo.offer.offerValue) ? '$' + currentSelectedVendor.strategyInfo.offer.offerValue + ' OFF' : currentSelectedVendor.strategyInfo.offer.offerValue + '% OFF'}}</div>
              <div style="font-size: 15px;">FOR TAXPLAN CUSTOMERS</div>
              <div *ngIf="currentSelectedVendor.strategyInfo.offer.link" class="pointer bold offer-link d-flex justify-content-center mt-3" (click)="openOfferLink()">Avail Offer</div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column mt-2 mb-2 media-content-box" *ngIf="documents.length > 0 || images.length > 0 || videos.length > 0">
      <div class="title bold mb-2">Media</div>
      <div class="d-flex flex-column" *ngIf="documents.length > 0">
        <div class="strategy-view-label mb-2" style="font-size: 13px;color: #667085;">Documents</div>
        <div class="d-flex align-items-center justify-content-start gap-3 flex-wrap">
          <div class="resource-file-box d-flex justify-content-between mb-2"  *ngFor="let file of documents; let i=index;">
            <div *ngIf="file.fileType === 'pdf'"><img src="../../../images/tpiq-icons/pdf-icon.png"/></div>
            <div *ngIf="file.fileType === 'excel'"><img src="../../../images/tpiq-icons/excel-icon.png"/></div>
            <div class="resource-name">{{file.name}}</div>
            <div class="pointer">
              <img (click)="getFileData(file)" src="../../../images/tpiq-icons/download_icon.png"/>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column" *ngIf="images.length > 0">
        <div class="strategy-view-label mb-2" style="font-size: 13px;color: #667085;">Images</div>
        <div class="image-preview mb-2" *ngIf="showPreview && currentSelectedImage && currentSelectedImage.link">
          <img class="image-zoom" [src]="currentSelectedImage.link"/>
        </div>
        <div class="d-flex align-items-center justify-content-start gap-3 flex-wrap">
          <div class="pointer mb-2 resource-image" [ngClass]="(currentSelectedImage && (file.name === currentSelectedImage.name)) ? 'selected-image' : ''" (click)="showImagePreview(file)" [ngStyle]="{'background-image': file.link ? 'url(' + file.link + ')': '', 'background-size': 'cover'}" *ngFor="let file of images; let i=index;"></div>
        </div>
      </div>
      <div class="d-flex flex-column" *ngIf="videos.length > 0">
        <div class="strategy-view-label mb-2" style="font-size: 13px;color: #667085;">Videos</div>
        <div class="d-flex align-items-center justify-content-start gap-3 flex-wrap">
          <div class="resource-video-box mb-2" *ngFor="let video of videos; let index = index;">
            <ng-template [ngIf]="video.name">
              <div class="d-flex justify-content-between">
                <div class="resource-name">{{video.name}}</div>
                <div class="pointer">
                  <img (click)="downloadVideo(video)" src="../../../images/tpiq-icons/download_icon.png"/>
                </div>
              </div>
              <div *ngIf="video" class="text-center mt-2">
                <video class="video-tag" style="margin: 0 auto;width: '100%'; height: 300px;" oncontextmenu="return false;" controlsList="nodownload" controls="" preload="auto" poster=""><source src="{{video.link}}" type="video/mp4"></video>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<div class="background-color" style="padding: 10px 15px 15px 15px;" *ngIf="strategyVendors && strategyVendors.length == 0">
  <div class="vendors-container d-flex align-items-center justify-content-center" style="height: 20vh;">
    No data available.
  </div>
</div>

